export default __webpack_public_path__ + "static/media/bg-2.16196e63.svg";